import { render, staticRenderFns } from "./VacancyIntro.vue?vue&type=template&id=677aa526"
import script from "./VacancyIntro.vue?vue&type=script&lang=js"
export * from "./VacancyIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports